export const permissionsAdmin = [
  { action: "manage", subject: "adminHome" },
  { action: "manage", subject: "adminEmployee" },
  { action: "manage", subject: "adminRole" },
  { action: "manage", subject: "adminStudent" },
  { action: "manage", subject: "adminRoom" },
  { action: "manage", subject: "adminClinicalCase" },
  { action: "manage", subject: "adminMentor" },
  { action: "manage", subject: "adminArea" },
  { action: "manage", subject: "adminClasses" },
  { action: "manage", subject: "adminPlan" },
  { action: "manage", subject: "adminCategoryItem" },
  { action: "manage", subject: "adminSupportMaterial" },
  { action: "manage", subject: "adminQuestion" },
  { action: "manage", subject: "adminClassRoom" },
  { action: "manage", subject: "adminLead" },
  { action: "manage", subject: "adminReport" },
  { action: "manage", subject: "adminSimulatedQuestion" },
  { action: "manage", subject: "adminIndication" },
  { action: "manage", subject: "adminDataGlobal" },
  { action: "manage", subject: "adminPhase" },
  { action: "manage", subject: "adminCalendar" },
  { action: "manage", subject: "adminCommentQuestionUser" },
  { action: "manage", subject: "adminCampaign" },
  { action: "manage", subject: "adminMeet" },
  { action: "manage", subject: "adminJitsiRecord" },
  { action: "manage", subject: "adminCoupon" },
  { action: "manage", subject: "adminUserLocationAccess" },
  { action: "manage", subject: "adminNotification" },
  { action: "manage", subject: "adminTimeline" },
  { action: "manage", subject: "adminTutorial" },
  { action: "manage", subject: "adminInstitution" },
  { action: "manage", subject: "adminRoomYoutube" },
  { action: "manage", subject: "adminAnalytic" },
];
